module.exports = __webpack_public_path__ + "media/images/payouts-f4eb067bc6e0dc5d053d4a1395625ba0.svg";